module.exports = __webpack_public_path__ + "static/img/20180414170003.3ea62396.jpg";